import { FC } from "react";
import { FormattedMessage } from "react-intl";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "~/components/ui/dialog";
import { ChronologyFormValues } from "../helpers/chronologyRequest";
import { ChronologyEventEditor } from "./ChronologyEventEditor";

interface ChronologyEventEditorModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  mode: "add" | "edit";
  initialValues?: ChronologyFormValues;
  isSaving: boolean;
  isLoadingSuggestion?: boolean;
  onSubmit: (values: ChronologyFormValues) => void;
}

export const ChronologyEventEditorModal: FC<
  ChronologyEventEditorModalProps
> = ({
  open,
  onOpenChange,
  mode,
  initialValues,
  isSaving,
  isLoadingSuggestion,
  onSubmit,
}) => {
  const titleId =
    mode === "add" ? "chronology.modal.addTitle" : "chronology.modal.editTitle";
  const descriptionId =
    mode === "add"
      ? "chronology.modal.addDescription"
      : "chronology.modal.editDescription";
  const submitLabelId = mode === "add" ? "chronology.action.create" : "save";

  const handleClose = () => {
    if (!isSaving) {
      onOpenChange(false);
    }
  };

  const handleOpenChange = (newOpen: boolean) => {
    if (!newOpen) {
      handleClose();
    }
  };

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent className="max-h-[85vh] overflow-y-auto sm:max-w-md">
        <DialogHeader className="space-y-1">
          <DialogTitle>
            <FormattedMessage id={titleId} />
          </DialogTitle>
          <DialogDescription>
            <FormattedMessage id={descriptionId} />
          </DialogDescription>
        </DialogHeader>
        <ChronologyEventEditor
          initialValues={initialValues}
          isSaving={isSaving}
          isLoadingSuggestion={isLoadingSuggestion}
          submitLabelId={submitLabelId}
          onSubmit={onSubmit}
          onCancel={handleClose}
        />
      </DialogContent>
    </Dialog>
  );
};
